import { render, staticRenderFns } from "./physicianDetail2.vue?vue&type=template&id=1ba81d23&scoped=true&"
import script from "./physicianDetail2.vue?vue&type=script&lang=js&"
export * from "./physicianDetail2.vue?vue&type=script&lang=js&"
import style0 from "./physicianDetail2.vue?vue&type=style&index=0&id=1ba81d23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba81d23",
  null
  
)

export default component.exports